import React, { useRef } from 'react';
import { TextFieldLabel, Select } from 'ui-component-library';
import { string, func } from 'prop-types';
import { LookupContainer } from './address-book-lookup.style';

import { searchPlaces, placesApi } from '../../../../utils/api/places';
import { createOption } from '../../../../utils/mappers';
import option from '../../../../shapes/option';

/**
 * Google Places Search for looking up a city/state.
 * @param {object} params - Object containing props
 * @param {string} params.label - Label of input
 * @param {string} params.placeholder - placeholder for the input
 * @param {func} params.onAddressChanged - Handles when the address changes in the input
 * @param {object} params.selectedAddress - State for component
 * @return {element}
 */
const AddressBookLookup = ({
  label, placeholder, onAddressChanged, selectedAddress,
}) => {
  // Keeps track of a session token for places autocomplete API
  const sessionTokenRef = useRef(placesApi ? new placesApi.AutocompleteSessionToken() : null);

  /**
   * Fetch options data based on a search value
   * @param {string} searchValue - Search Value
   * @return {object[]} - Fetched options
   */
  const fetchOptionData = async (searchValue) => {
    if (!sessionTokenRef.current) {
      return null;
    }
    const res = await searchPlaces(searchValue, sessionTokenRef.current);
    if (res) {
      return res.map((prediction) => createOption(prediction.description));
    }
    return [];
  };

  return (
    <LookupContainer>
      <TextFieldLabel text={label} />
      <Select
        placeholder={placeholder}
        selectedValue={selectedAddress}
        options={[]}
        onValueChange={onAddressChanged}
        optionLoader={fetchOptionData}
        icon="Address-Book"
      />
    </LookupContainer>
  );
};

AddressBookLookup.propTypes = {
  label: string,
  placeholder: string,
  onAddressChanged: func,
  selectedAddress: option,
};

AddressBookLookup.defaultProps = {
  label: '',
  placeholder: '',
  onAddressChanged: () => { },
  selectedAddress: null,
};

export default AddressBookLookup;
